module.exports = __webpack_public_path__ + "img/rgs.058d9e74.png";